import React from "react";
import { Landmark, Scale, ShieldCheck } from "lucide-react";
import { Reveal } from "../hooks/useReveal";
import { services } from "../data/siteContent";

const iconMap = { Landmark, Scale, ShieldCheck };

const WhatWeDo = () => {
  return (
    <section
      className="bg-ink py-24 sm:py-36 relative overflow-hidden"
      data-testid="what-we-do-section"
    >
      <div
        className="absolute top-0 left-1/3 w-[600px] h-[400px] bg-gold/5 blur-[120px] rounded-full"
        aria-hidden="true"
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <Reveal>
          <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
            <span className="h-px w-10 bg-gold/60" />
            What We Do
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-cream tracking-tight leading-[1.06] mt-6">
            One Portal. <em className="text-gold italic">Complete Protection.</em>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 mt-14 sm:mt-20">
          {services.map((service, idx) => {
            const Icon = iconMap[service.icon];
            return (
              <Reveal key={service.title} className="h-full" delay={idx * 80}>
                <div
                  className="group h-full bg-surface border border-white/8 rounded-2xl p-8 sm:p-10 hover:border-gold/40 hover:-translate-y-1.5 transition-[border-color,transform] duration-500"
                  data-testid={`service-card-${idx}`}
                >
                  <div className="w-14 h-14 rounded-full bg-gold/10 border border-gold/25 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-ink transition-colors duration-500">
                    <Icon className="w-6 h-6" strokeWidth={1.8} />
                  </div>
                  <h3 className="font-display text-xl text-cream mt-8">{service.title}</h3>
                  <p className="text-cream/65 leading-relaxed mt-4 text-sm sm:text-base">
                    {service.text}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
